var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithbuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510.006 510.006",
    height: 512,
    viewBox: "0 0 510.006 510.006",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.003 105.006c-8.271 0-15 6.729-15 15 .755 19.872 29.249 19.867 30 0 0-8.272-6.729-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.382 71.211-191.379-71.211-191.404 71.271-62.947 153.735h508.701zm-191.379 93.795c-24.813 0-45-20.188-45-45 2.262-59.617 87.747-59.6 90 .001 0 24.811-20.187 44.999-45 44.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.003 493.491 81.04-65.845-81.04-65.677z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.251 510.006h155.419l-77.809-63.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.003 493.542v-132.021l-81.349 66.095z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.003 510.006h90v-195h270v195h90v-255h-450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.754 345.006h-156.035l78.118 63.307z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithbuilding);
export default __webpack_public_path__ + "static/media/withbuilding.ad7a159f110b8824fc2528b810b060ce.svg";
export { ForwardRef as ReactComponent };